import { useTranslation } from 'react-i18next'
import { Skeleton } from '@/components/ui/skeleton.tsx'
import { BackToPrevPageLink } from '@/feature/fundraising-advisory/components/BackToPrevPageLink.tsx'
import { PageBody, PageHeader } from '@/components/shared/page-sections.tsx'
import { ScrollableRouteContainer } from '@/components/shared/Container.tsx'

export const BusinessInfoPageSkeleton = () => {
  const { t } = useTranslation(`fundraising`)
  return (
    <ScrollableRouteContainer className={`p-0`}>
      <PageHeader className={`flex flex-col gap-6`}>
        <BackToPrevPageLink to={`..`} className={`inline-flex self-start`}>
          {t(`fundraising.navigation.back_to_index`)}
        </BackToPrevPageLink>
        <div className={`flex flex-col gap-1 px-2`}>
          <h1 className={`text-2xl font-semibold text-primary`}>{t(`fundraising.business_information.index.title`)}</h1>
          <h2 className={`text-base font-normal text-secondary`}>{t(`fundraising.business_information.index.subtitle_existing_infos`)}</h2>
        </div>
      </PageHeader>
      <PageBody>
        <Skeleton className='h-[459px] rounded-xl' />
      </PageBody>
    </ScrollableRouteContainer>
  )
}
